const ITEM_CHARACTERISTIC = {
  organic: {
    name: 'ORGANIC',
  },
  vegan: {
    name: 'VEGAN',
  },
  additiveFree: {
    name: 'ADDITIVE_FREE',
  },
  lactoseFree: {
    name: 'LACTOSE_FREE',
  },
  sugarFree: {
    name: 'SUGAR_FREE',
  },
  glutenFree: {
    name: 'GLUTEN_FREE',
  },
  nutFree: {
    name: 'NUT_FREE',
  },
  lowCarbohydrates: {
    name: 'LOW_CARBOHYDRATES',
  },
  spicy: {
    name: 'SPICY',
  },
};

export default ITEM_CHARACTERISTIC;
